module.exports = __webpack_public_path__ + "static/media/me3_Heart_Filled_Icon.d2ea78e8.svg";